import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:9890/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Only redirect to login for 401 errors from critical auth endpoints
    // Don't redirect for optional services like wallet or tournaments
    const isAuthCritical = error.config.url.includes('/api/auth/me') || 
                          error.config.url.includes('/api/users');
    const isOptionalService = error.config.url.includes('/api/wallet') ||
                             error.config.url.includes('/api/tournaments');
    
    if (error.response?.status === 401 && 
        !error.config.url.includes('/api/auth/login') && 
        isAuthCritical && 
        !isOptionalService) {
      // Unauthorized on critical endpoints - clear token and redirect to login
      localStorage.removeItem('token');
      delete api.defaults.headers.common['Authorization'];
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

// Import and export tier API
export { tierApi } from './tierApi';